import styled from 'styled-components';

export const InfoWrapper = styled.div`
  display: flex;
  gap: 100px;
  margin-bottom: 48px;

  @media ${(props) => props.theme.device.mobileL} {
    align-items: start;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;

    > div,
    .d-flex {
      width: 100%;
    }
  }
`;
